import type { Engine } from "../../../../engine/Engine";
import {
  SEGMENT_DRAFT_DIMENSION_EVENT,
  type SegmentDraftDimensionDetail,
} from "../../../../shape/segment/segmentPointerEvents";
import type { SegmentSpec } from "../../../../shape/segment/types";

/** Draw + seçili segment — aynı ölçü label event'i. */
export function dispatchSegmentLengthDimension(
  engine: Engine,
  spec: SegmentSpec | null,
  opts: Omit<SegmentDraftDimensionDetail, "spec"> = {},
): void {
  engine.dispatchCustomEvent(SEGMENT_DRAFT_DIMENSION_EVENT, {
    detail: { spec, ...opts },
  });
}
